import React from "react";
import { connect } from "react-redux";
import { Tabs } from "../../../components/Tabs";
import language from "../../../language";
import BloodCollection from "../../../components/BloodCollection/BloodCollection";
import BloodTesting from "../../../components/BloodTesting/BloodTesting";
import BlockedBloodCollection from "../../../components/BloodCollection/BlockedBloodCollection";
import {
  ROLE_BLOOD_TEST,
  ROLE_COLLECTIONS,
  ROLE_PACKAGING,
} from "../../../constants/ROLES";
import { getStorage } from "../../../utils/storage";
import { defineRole } from "../../../utils/handleAccessRoles";
import SearchDonation from "../../../components/BloodCollection/SearchDonation";
import Transfer from "../../../components/BloodCollection/Transfer";
import Packaging from "../../../components/BloodCollection/Packaging";

class BloodDonationScreen extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };
  render() {
    const roles = this.state?.user?.accessRole || [];

    let tabOptions = [
      {
        title: language[this.props.defaultLanguage].search_by_donation,
        data: (
          <div className="card">
            <div className="col-md-6">
              <div className="card-bold">
                <SearchDonation
                  filters={this.props.filters}
                  showResultModal
                  navigationUrl="/dashboard/donations"
                />
              </div>
            </div>
          </div>
        ),
      },
    ];

    const canAccessCollection = defineRole({
      roles,
      menu: ROLE_COLLECTIONS,
      operation: "read",
    });

    const canBloodTest = defineRole({
      roles,
      menu: ROLE_BLOOD_TEST,
      operation: "read",
    });

    const canTransferSwipeDonation = defineRole({
      roles,
      menu: ROLE_COLLECTIONS,
      operation: "transferSwipeDonation",
    });

    const canReadPackaging = defineRole({
      roles,
      menu: ROLE_PACKAGING,
      operation: "read",
    });

    if (canReadPackaging) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].packaging,
        data: <Packaging status={["pending", "transferred", "received"]} />,
      });
    }

    if (canAccessCollection) {
      tabOptions.push(
        {
          title: language[this.props.defaultLanguage].collections,
          data: <BloodCollection />,
        },
        {
          title: language[this.props.defaultLanguage].blocked_donations,
          data: <BlockedBloodCollection />,
        }
      );
    }

    if (canBloodTest) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].blood_testing,
        data: <BloodTesting />,
      });
    }

    if (canTransferSwipeDonation) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].transfer_swipe_donation,
        data: (
          <Tabs
            options={[
              {
                title: "Transfer to new Donor",
                data: (
                  <div className="card">
                    <div className="col-md-8">
                      <div className="card-body">
                        <Transfer />
                      </div>
                    </div>
                  </div>
                ),
              },
              // {
              //   title: "Swipe Donation to Donation",
              //   data: (
              //     <div className="card">
              //       <div className="col-md-8">
              //         <div className="card-body">
              //           <Swipe />
              //         </div>
              //       </div>
              //     </div>
              //   ),
              // },
              // {
              //   title: "Historical Data",
              //   data: (
              //     <div className="card">
              //       <div className="col-md-8">
              //         <div className="card-body">
              //           <TransferLogs />
              //         </div>
              //       </div>
              //     </div>
              //   ),
              // },
            ]}
          />
        ),
      });
    }

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Tabs options={tabOptions} mountOnEnter unmountOnExit={false} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BloodDonationScreen);
